"use client"

import { MobileBottomBar } from "@shared/ui/landing/mobile-bottom-bar"
import { buttonVariants } from "@shared/ui/components/button"
import { cn } from "@shared/ui/lib/utils"

import { useTranslations } from "@/lib/i18n/client"
import { StartScanButton } from "@/components/start-scan-button"

export function MobileBottomCta() {
  const t = useTranslations("hero")

  return (
    <MobileBottomBar>
      <div className="flex gap-2">
        <StartScanButton size="default" className="flex-1" />
        <a
          href="#report"
          className={cn(
            buttonVariants({ variant: "outline", size: "default" }),
            "flex-1 border-white/15 bg-white/5",
          )}
        >
          {t("viewSample")}
        </a>
      </div>
    </MobileBottomBar>
  )
}
